import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { useTheme } from '../../hooks/useTheme'

const PlusIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
)

interface DashedAddButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'style'> {
  children: ReactNode
  /** Defaults to a plus icon. Pass `null` to hide the icon. */
  icon?: ReactNode | null
  className?: string
}

/**
 * Full-width dashed “add item” CTA. Matches program edit → add block.
 */
export function DashedAddButton({
  children,
  icon = PlusIcon,
  className = '',
  type = 'button',
  ...props
}: DashedAddButtonProps) {
  const theme = useTheme()

  return (
    <button
      type={type}
      className={`w-full rounded-2xl p-3.5 text-sm border-2 border-dashed transition-opacity hover:opacity-70 flex items-center justify-center gap-2 ${className}`.trim()}
      style={{ borderColor: theme.cardBorder, color: theme.text.muted }}
      {...props}
    >
      {icon}
      {children}
    </button>
  )
}
